(function () {
  function norm(str) {
    return (str || '').trim().toLowerCase().replace(/[’‘]/g, "'").replace(/\s*[?!.:]+$/, '').replace(/\s+/g, ' ');
  }

  // Section headings per language (en, fr, de, lb, it, nl, es, hr), matched after norm()
  var HEADINGS = {
    use: ['who should use it', "à qui s'adresse-t-il", 'für wen geeignet', 'für wen ist sie geeignet', 'fir wien geeegent', 'fir wien gëeegent', 'per chi è adatta', 'voor wie is het geschikt', 'para quién es', 'za koga je'],
    notUse: ['who should not use it', "à qui ne s'adresse-t-il pas", 'für wen nicht geeignet', 'für wen ist sie nicht geeignet', 'net geeegent fir', 'net gëeegent fir', 'per chi non è adatta', 'voor wie is het niet geschikt', 'para quién no es', 'za koga nije'],
    hybrid: ['hybrid setups & performance adjustments', 'hybrid setups and performance adjustments', 'montages hybrides et ajustements de performance', 'hybrid-setups & leistungsanpassungen', 'hybrid-montage a leeschtungsuspassungen', 'montaggi ibridi e regolazioni delle prestazioni', 'hybride besnaringen en prestatie-aanpassingen', 'montajes híbridos y ajustes de rendimiento', 'hibridne postave i prilagodbe izvedbe'],
    specs: ['technical specifications', 'caractéristiques techniques', 'technische daten', 'technesch specifikatiounen', 'specifiche tecniche', 'technische specificaties', 'especificaciones técnicas', 'tehničke specifikacije']
  };

  function nodesUntilNextH2(h2) {
    var nodes = [];
    var n = h2.nextElementSibling;
    while (n && n.tagName !== 'H2') {
      var next = n.nextElementSibling;
      nodes.push(n);
      n = next;
    }
    return nodes;
  }

  function buildFitGrid(root, useH2, notH2) {
    var useNodes = nodesUntilNextH2(useH2);
    var notNodes = nodesUntilNextH2(notH2);
    var useUl = useNodes.filter(function (n) { return n.tagName === 'UL'; })[0];
    var notUl = notNodes.filter(function (n) { return n.tagName === 'UL'; })[0];
    if (!useUl || !notUl) return;

    var grid = document.createElement('div');
    grid.className = 'tc-fit-grid';

    var goodCard = document.createElement('div');
    goodCard.className = 'tc-fit-card tc-fit-card--good';
    var goodTitle = document.createElement('h3');
    goodTitle.className = 'tc-fit-card__title';
    goodTitle.textContent = useH2.textContent.trim();
    goodCard.appendChild(goodTitle);
    goodCard.appendChild(useUl);

    var badCard = document.createElement('div');
    badCard.className = 'tc-fit-card tc-fit-card--bad';
    var badTitle = document.createElement('h3');
    badTitle.className = 'tc-fit-card__title';
    badTitle.textContent = notH2.textContent.trim();
    badCard.appendChild(badTitle);
    badCard.appendChild(notUl);

    grid.appendChild(goodCard);
    grid.appendChild(badCard);

    useH2.parentNode.insertBefore(grid, useH2);

    var extraNotes = notNodes.filter(function (n) {
      return n !== notUl && n.tagName === 'P';
    });

    useH2.remove();
    useNodes.forEach(function (n) { if (n !== useUl) n.remove(); });
    notH2.remove();
    notNodes.forEach(function (n) {
      if (n === notUl) return;
      if (n.tagName === 'P') return;
      n.remove();
    });

    var after = grid.nextSibling;
    extraNotes.forEach(function (p) {
      p.classList.add('tc-fit-note');
      grid.parentNode.insertBefore(p, after);
    });
  }

  function buildHybridGrid(hybridH2) {
    var nodes = nodesUntilNextH2(hybridH2);
    var paragraphs = nodes.filter(function (n) { return n.tagName === 'P' && n.querySelector('strong'); });
    if (!paragraphs.length) return;

    var grid = document.createElement('div');
    grid.className = 'tc-hybrid-grid';

    paragraphs.forEach(function (p) {
      var strong = p.querySelector('strong');
      var label = strong ? strong.textContent.trim() : '';
      var clone = p.cloneNode(true);
      var cloneStrong = clone.querySelector('strong');
      if (cloneStrong) cloneStrong.remove();
      var text = clone.innerHTML.replace(/^<br\s*\/?>/i, '').trim();

      var card = document.createElement('div');
      card.className = 'tc-hybrid-card';
      var labelEl = document.createElement('span');
      labelEl.className = 'tc-hybrid-card__label';
      labelEl.textContent = label;
      var textEl = document.createElement('span');
      textEl.className = 'tc-hybrid-card__text';
      textEl.innerHTML = text;
      card.appendChild(labelEl);
      card.appendChild(textEl);
      grid.appendChild(card);
    });

    hybridH2.parentNode.insertBefore(grid, hybridH2.nextSibling);
    nodes.forEach(function (n) { n.remove(); });
  }

  function buildSpecTable(specsH2) {
    var nodes = nodesUntilNextH2(specsH2);
    var rows = [];
    nodes.forEach(function (p) {
      if (p.tagName !== 'P') return;
      var br = p.querySelector('br');
      if (!br) return;
      var label = '';
      var valueParts = [];
      var seenBr = false;
      p.childNodes.forEach(function (child) {
        if (child === br) { seenBr = true; return; }
        var text = child.textContent || '';
        if (!seenBr) label += text;
        else valueParts.push(text);
      });
      label = label.replace(/:\s*$/, '').trim();
      var value = valueParts.join('').trim();
      if (label && value) rows.push([label, value]);
    });
    if (!rows.length) return;

    var table = document.createElement('table');
    table.className = 'tc-spec-table';
    rows.forEach(function (row) {
      var tr = document.createElement('tr');
      var th = document.createElement('th');
      th.textContent = row[0];
      var td = document.createElement('td');
      td.textContent = row[1];
      tr.appendChild(th);
      tr.appendChild(td);
      table.appendChild(tr);
    });

    specsH2.parentNode.insertBefore(table, specsH2.nextSibling);
    nodes.forEach(function (n) { n.remove(); });
  }

  function enhance(root) {
    if (!root || root.dataset.tcEnhanced) return;
    root.dataset.tcEnhanced = '1';

    var h2s = Array.prototype.slice.call(root.querySelectorAll('h2'));
    var useH2, notH2, hybridH2, specsH2;
    h2s.forEach(function (h) {
      var t = norm(h.textContent);
      if (HEADINGS.use.indexOf(t) > -1) useH2 = h;
      else if (HEADINGS.notUse.indexOf(t) > -1) notH2 = h;
      else if (HEADINGS.hybrid.indexOf(t) > -1) hybridH2 = h;
      else if (HEADINGS.specs.indexOf(t) > -1) specsH2 = h;
    });

    if (useH2 && notH2) buildFitGrid(root, useH2, notH2);
    if (hybridH2) buildHybridGrid(hybridH2);
    if (specsH2) buildSpecTable(specsH2);
  }

  function init() {
    document.querySelectorAll('.tc-desc').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
